import { useState } from 'react';
import Card from 'components/card';
import { ReadPermissionGate } from 'components/PermissionGate';
import { PERMISSION_RESOURCES } from 'constants/permissions';
import { CardFees } from 'views/admin/CardFees';
import { ContractFeesPanel } from './components/ContractFeesPanel';
import { SwapFeePanel } from './components/SwapFeePanel';

const TABS = [
  { key: 'crypto', label: 'Deposit / Withdrawal' },
  { key: 'swap', label: 'Swap' },
  { key: 'cards', label: 'Cards' },
] as const;

type TTabKey = (typeof TABS)[number]['key'];

/**
 * Fees hub (Fees Amendment): every product fee in one place. Crypto and swap
 * fees are new editors; the Cards tab reuses the CardFees editor. (Dev also
 * has an Invoice Payments tab — added here once invoice payments ships to
 * prod.)
 */
export const Fees = () => {
  const [tab, setTab] = useState<TTabKey>('crypto');

  return (
    <ReadPermissionGate
      resource={PERMISSION_RESOURCES.FEES}
      fallback={
        <div className="mt-5 text-center text-gray-600 dark:text-white">
          You don&apos;t have access to Fees Management.
        </div>
      }
    >
      <div className="mt-3">
        <Card extra="p-4">
          <div className="mb-4 flex flex-wrap gap-2">
            {TABS.map(item => (
              <button
                key={item.key}
                onClick={() => setTab(item.key)}
                className={`rounded px-3 py-2 text-sm font-medium ${
                  tab === item.key
                    ? 'bg-brand-500 text-white'
                    : 'border border-gray-200 text-navy-700 dark:text-white'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
          {tab === 'crypto' && <ContractFeesPanel />}
          {tab === 'swap' && <SwapFeePanel />}
          {tab === 'cards' && <CardFees />}
        </Card>
      </div>
    </ReadPermissionGate>
  );
};

export default Fees;
